module.exports = __webpack_public_path__ + "img/refresh.d5cd373d.svg";